<template>
  <el-dialog
    :append-to-body="true"
    title="新增访客记录"
    :visible.sync="drawerShow"
    direction="ltr"
    :wrapperClosable="false"
    :close-on-press-escape="false"
    :before-close="handleClose"
  >
    <el-form
      :model="ruleForm"
      :rules="rules"
      ref="ruleForm"
      style="max-height:780px;overflow: auto"
      label-width="130px"
      class="demo-ruleForm"
    >
      <el-form-item label="访客姓名:" prop="visitorName">
        <el-input
          style="width:90%"
          v-model="ruleForm.visitorName"
          placeholder="请输入访客姓名"
          clearable
          size="small"
        ></el-input>
      </el-form-item>
      <el-form-item label="访客手机号码:" prop="visitorMobileNumber">
        <el-input
          style="width:90%"
          v-model="ruleForm.visitorMobileNumber"
          placeholder="请输入访客手机号码"
          clearable
          size="small"
        ></el-input>
      </el-form-item>
      <el-form-item label="身份证号码:" prop="identificationNumber">
        <el-input
          style="width:90%"
          v-model="ruleForm.identificationNumber"
          placeholder="请输入身份证号码"
          clearable
          size="small"
        ></el-input>
      </el-form-item>
      <el-form-item label="访客单位:" prop="visitorUnit">
        <el-input
          style="width:90%"
          v-model="ruleForm.visitorUnit"
          placeholder="请输入访客单位"
          clearable
          size="small"
        ></el-input>
      </el-form-item>
      <el-form-item label="来访时间:" prop="visitingTime">
        <el-date-picker
          v-model="ruleForm.visitingTime"
          type="date"
          placeholder="选择来访时间"
          align="right"
          size="small"
          style="width:90%"
          value-format="timestamp"
          :picker-options="pickerOptionsStart"
          @change="changeStart"
        >
        </el-date-picker>
      </el-form-item>
      <el-form-item label="离开时间:" prop="departureTime">
        <el-date-picker
          v-model="ruleForm.departureTime"
          type="date"
          placeholder="选择来访时间"
          align="right"
          size="small"
          style="width:90%"
          value-format="timestamp"
          :picker-options="pickerOptionsEnd"
          @change="changeEnd"
        >
        </el-date-picker>
      </el-form-item>
      <el-form-item label="来访目的:" prop="purposeVisit">
        <el-input
          style="width:90%"
          v-model="ruleForm.purposeVisit"
          placeholder="请输入来访目的"
          type="textarea"
          :autosize="{ minRows: 1, maxRows: 3 }"
          clearable
          size="small"
        ></el-input>
      </el-form-item>
      <el-form-item label="来访人数:" prop="numberVisitors">
        <el-input
          style="width:90%"
          v-model="ruleForm.numberVisitors"
          placeholder="请输入来访人数"
          clearable
          size="small"
        ></el-input>
      </el-form-item>
      <el-form-item label="车牌:" prop="licensePlateRegistration">
        <el-input
          style="width:90%"
          v-model="ruleForm.licensePlateRegistration"
          placeholder="请输入车牌"
          clearable
          size="small"
        ></el-input>
      </el-form-item>
      <el-form-item label="访客照片:" prop="visitorPhotos">
        <head-portrait-upLoad
          :imageUrl="ruleForm.visitorPhotos"
          @imageChange="visitorImageChange"
        ></head-portrait-upLoad>
      </el-form-item>
      <el-form-item label="被访人:" prop="intervieweeId">
        <el-select
          v-model="ruleForm.intervieweeId"
          style="width:90%"
          size="small"
          clearable
          placeholder="请选择被访人"
        >
          <el-option
            v-for="item in allTeachers"
            :key="item.id"
            :label="item.Name"
            :value="item.id"
          >
          </el-option>
        </el-select>
      </el-form-item>
    </el-form>
    <div class="demo-drawer__footer insert_data_button_box">
      <div class="col-sm-12 text-center">
        <el-button
          type="primary"
          size="small"
          @click="saveForm('ruleForm')"
          v-loading="loading"
          >提交</el-button
        >
        <el-button @click="handleClose" size="small" v-loading="loading"
          >返回</el-button
        >
      </div>
    </div>
  </el-dialog>
</template>
<script>
import HeadPortraitUpLoad from "@/components/HeadPortraitUpLoad";
export default {
  name: "VisitorRecordAdd",
  components: {
    HeadPortraitUpLoad
  },
  props: {
    drawerShow: {
      type: Boolean,
      default: {
        return: false
      }
    }
  },
  data() {
    var reg = /^1[3456789]\d{9}$/;
    var checkPhone = (rule, value, callback) => {
      if (value === "") {
        callback(new Error(" "));
      } else if (!reg.test(value)) {
        callback(new Error(" "));
      } else {
        callback();
      }
    };
    var idcard_patter = /^[1-9][0-9]{5}([1][9][0-9]{2}|[2][0][0|1][0-9])([0][1-9]|[1][0|1|2])([0][1-9]|[1|2][0-9]|[3][0|1])[0-9]{3}([0-9]|[X])$/;
    var checkIdCard = (rule, value, callback) => {
      if (value === "") {
        callback(new Error(" "));
      } else if (!idcard_patter.test(value)) {
        callback(new Error(" "));
      } else {
        callback();
      }
    };
    var num = /^[0-9]*[1-9][0-9]*$/;
    var checkNum = (rule, value, callback) => {
      if (value === "") {
        callback(new Error(" "));
      } else if (!num.test(value)) {
        callback(new Error(" "));
      } else {
        callback();
      }
    };
    // 车牌号校验
    var plate = /^([京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼使领A-Z]{1}[a-zA-Z](([DF]((?![IO])[a-zA-Z0-9](?![IO]))[0-9]{4})|([0-9]{5}[DF]))|[京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼使领A-Z]{1}[A-Z]{1}[A-Z0-9]{4}[A-Z0-9挂学警港澳]{1})$/;
    var checkPlate = (rule, value, callback) => {
      if (value === "") {
        callback(new Error(" "));
      } else if (!plate.test(value)) {
        callback(new Error(" "));
      } else {
        callback();
      }
    };
    return {
      ruleForm: {
        visitorName: "", //访客姓名
        visitorMobileNumber: "", //访客手机号码
        identificationNumber: "", //身份证号码
        visitorUnit: "", //访客单位
        visitingStatus: 0, //来访状态
        visitingTime: "", //来访时间
        departureTime: "", //离开时间
        purposeVisit: "", //来访目的
        numberVisitors: "", //来访人数
        licensePlateRegistration: "", //车牌登记
        visitorPhotos: "", //访客照片
        schoolId: this.$store.state.schoolId, //所属学校
        intervieweeId: "" //被访人id
      },
      loading: false,
      allTeachers: [], //被访人列表
      rules: {
        visitorName: [{ required: true, message: " ", trigger: "blur" }],
        visitorMobileNumber: [
          { required: true, validator: checkPhone, trigger: "blur" }
        ],
        identificationNumber: [
          { required: true, validator: checkIdCard, trigger: "blur" }
        ],
        visitorUnit: [{ required: true, message: " ", trigger: "blur" }],
        visitingTime: [{ required: true, message: " ", trigger: "change" }],
        departureTime: [{ required: true, message: " ", trigger: "change" }],
        numberVisitors: [
          { required: true, validator: checkNum, trigger: "blur" }
        ],
        purposeVisit: [{ required: true, message: " ", trigger: "blur" }],
        licensePlateRegistration: [
          { required: true, validator: checkPlate, trigger: "blur" }
        ],
        visitorPhotos: [{ required: true, message: " ", trigger: "change" }],
        intervieweeId: [{ required: true, message: " ", trigger: "change" }]
      },
      pickerOptionsStart: {},
      pickerOptionsEnd: {}
    };
  },
  mounted() {
    this.getAllTeachers();
  },
  methods: {
    visitorImageChange(src) {
      this.ruleForm.visitorPhotos = src || "";
    },
    async getAllTeachers() {
      let req = {
        pageSize: 10000,
        pageNum: 1,
        schoolId: parseInt(this.$store.state.schoolId),
        departmentId: "",
        userPhone: "",
        userName: ""
      };
      let res = await this.$Http.getTeacherList(req, true);
      if (res.code == 200) {
        this.allTeachers = res.data.list || [];
      } else if (res.code == 101) {
        this.allTeachers = [];
      } else {
        this.allTeachers = [];
      }
    },
    saveForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.loading = true;

          this.addInfo();
        } else {
          return false;
        }
      });
    },
    async addInfo() {
      let req = Object.assign({}, this.ruleForm);
      req.visitingTime = Number(req.visitingTime) / 1000;
      req.departureTime = Number(req.departureTime) / 1000;
      let res = await this.$Http.addVisitorRecord(req);
      this.loading = false;
      if (res.code == 200) {
        this.handleClose(true);
      } else {
        this.$message({
          type: "error",
          message: res.messsage || "新增失败"
        });
      }
    },
    //   关闭抽屉
    handleClose(type) {
      this.$emit("handleClose", type);
      this.visitorPhotos = "";
      this.$refs.ruleForm.resetFields();
    },

    changeStart() {
      // 限制开始时间
      // console.log(this.ruleForm.visitingTime);
      this.pickerOptionsEnd = Object.assign({}, this.pickerOptionsEnd, {
        disabledDate: (time) => {
          if (this.ruleForm.visitingTime) {
            return time.getTime() < this.ruleForm.visitingTime;
          }
        }
      });
    },
    changeEnd() {
      // 限制结束时间
      // console.log(this.ruleForm.departureTime);
      this.pickerOptionsStart = Object.assign({}, this.pickerOptionsStart, {
        disabledDate: (time) => {
          if (this.ruleForm.departureTime) {
            //如果没有后面的-8.64e7就是不可以选择今天的
            //减去一天的时间代表可以选择同一天; 1*24*60*60*1000;
            return time.getTime() > this.ruleForm.departureTime - 8.64e7; //-8.64e7可以让开始时间和结束时间选同一天
          }
        }
      });
    }
  }
};
</script>
